import React from "react";
import "dayjs/locale/en-gb";
import { DemoContainer, DemoItem } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { styled } from "@mui/material/styles";
import IconButton from "@mui/material/IconButton";
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import FlightTakeoffIcon from "@mui/icons-material/FlightTakeoff";

function SelectDate({ readOnly=false, dateLabel, dateName, value, onChange }) {
  const StyledButton = styled(IconButton)(({ theme }) => ({
    borderRadius: theme.shape.borderRadius,
  }));
  const StyledDay = styled(PickersDay)(({ theme }) => ({
    borderRadius: theme.shape.borderRadius,
    color:
      theme.palette.mode === "light"
        ? theme.palette.secondary.dark
        : theme.palette.secondary.light,
  }));
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-gb">
      <DemoContainer components={["MobileDatePicker"]}>
        <DemoItem label={dateLabel}>
          <MobileDatePicker
            readOnly={readOnly}
            disableCloseOnSelect={false}
            name={dateName}
            value={value}
            onChange={(newDate) => onChange(newDate)}
            slots={{
              openPickerIcon: FlightTakeoffIcon,
              openPickerButton: StyledButton,
              day: StyledDay,
            }}
            slotProps={{
              actionBar: {
                actions: ["clear", "today", "accept"],
              },
              openPickerIcon: { fontSize: "large" },
              openPickerButton: { color: "secondary" },
              textField: {
                variant: "filled",
                focused: true,
                color: "secondary",
              },
            }}
          />
        </DemoItem>
      </DemoContainer>
    </LocalizationProvider>
  );
}

export default SelectDate;
